module.exports = ".clear-button {\n  position: absolute;\n  right: 16px; }\n"